/**
 * MovesSection - View component for displaying and editing moves
 * Pure presentation component that delegates all logic to ViewModel
 */

import React from 'react';
import MoveItem from './MoveItem';

export default function MovesSection({ viewModel }) {
  return (
    <div>
      <h2>Handwritten Moves</h2>
      <div className="moves-grid" style={styles.movesGrid}>
        {viewModel.moves && viewModel.moves.length > 0 && viewModel.moves.map((moveObj, index) => (
          <MoveItem
            key={index}
            index={index}
            moveObj={moveObj}
            viewModel={viewModel}
          />
        ))}
      </div>
    </div>
  );
}

const styles = {
  movesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(10, 1fr)',
    gap: '8px',
    marginBottom: '12px'
  }
};
